import React from 'react';
import ExpandMoreIconMUI from '@material-ui/icons/ExpandMore';

export default function ExpandMoreIcon(props) {
  return (
    <ExpandMoreIconMUI
      style={{
        color: props.color,
        transform:
          props.expanded === false ? 'rotate(-90deg)' : 'rotate(180deg)',
      }}
    />
  );
}
